import React from 'react'

const Finance = () => {
  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-8 font-sans">

      <h1 className='font-bold text-[38px]'>
        Finances 
      </h1>
    </div>
  )
}

export default Finance
